export enum FantasyRarity {
    Bronze,
    Silver,
    ShinySilver,
    Gold,
    ShinyGold,
}